import React, { forwardRef } from 'react';

import { bemCssModules, getTestId } from '@utils';

import Field from '../../Field';
import ArrowIcon from '../arrow.svg';

import style from './SelectField.scss';

const cn = bemCssModules(style, 'SelectField');
const ti = getTestId('SelectField');

export type TSelectField = {
  className?: string;
  children: React.ReactNode;
  label: string;
};

const SelectField = forwardRef<HTMLButtonElement, TSelectField>((props, ref) => {
  const { className, children, label } = props;

  return (
    <button className={cn(null, [className])} ref={ref} type="button" data-testid={ti()}>
      <Field
        tag="div"
        value={<div>{label}</div>}
        right={
          <div className={cn('value')}>
            <small className={cn('name')}>{children}</small>
            <ArrowIcon className={cn('arrow')} />
          </div>
        }
      />
    </button>
  );
});

export default SelectField;
